import React, { useState, useEffect, useContext } from "react";
import companyLogo from '../content/img/logo.png';
import companyLogoWhite from '../content/img/logo-w.png';
import SearchFilter from "./SearchFilter";
import { NavLink } from "react-router-dom";
import MenuLink from "../utilities/MenuLink";
import BookNow from "./BookNow";
import BookNowMobile from "./BookNowMobile";


const Header = ({ background }) => {


  const isHomePage = window.location.href === process.env.REACT_APP_SITE_URL;

  const [isMobile, setIsMobile] = useState(window.matchMedia("screen and (max-width: 767px)").matches);
  const [isTablet, setIsTablet] = useState(window.matchMedia("screen and (max-width: 991px)").matches);
  const [isSticky, setIsSticky] = useState(false);


  useEffect(() => {
    if (!isHomePage) return;
    const handleResize = () => {
      setIsMobile(window.matchMedia("screen and (max-width: 767px)").matches);
      setIsTablet(window.matchMedia("screen and (max-width: 991px)").matches);
    };

    const handleScroll = () => {
      if (!isMobile) {
        // if (window.scrollY > 0) {
        //   setIsSticky(true);
        // } else {
        //   setIsSticky(false);
        // }
       if (window.scrollY > (window.innerHeight + window.innerHeight)) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    }}

    window.addEventListener("scroll", handleScroll);

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile]);

  const openMenu = () => {
    document.getElementById('Menu').classList.add('active');
    document.getElementsByTagName('Body')[0].classList.add('menuOpen');
    // document.getElementsByTagName('Html')[0].style.overflow = "hidden";
    // document.getElementById('root').style.overflow = "hidden";
  };

  const closeMenu = () => {
    document.getElementById('Menu').classList.remove('active');
    document.getElementsByTagName('Body')[0].classList.remove('menuOpen');
    document.getElementsByTagName('Html')[0].style.overflow = "inherit";
    document.getElementById('root').style.overflow = "inherit";
  };

  const logoFeeling = (background === "transparent" || background === "black" || isSticky) ? companyLogoWhite : companyLogo;

  return (     
      <header className={`${isSticky ? "background-black position-fixed top-0" : `bg-${background}`}`}>
        <div className="container-fluid p-80">
          {!isMobile && !isTablet && background !== "white" && (
          <div className="gradient-overlay-up z-n1"></div>
          )}
          <div className={`row ${isSticky ? (isMobile || isTablet ? "pt-3" : "pt-0") : (isMobile || isTablet ? "pt-4 pb-2" : "pt-0 pb-0")}`}>
            <div className="col-12">
              {isMobile || isTablet ? (
                <div className="mobile-menu">
                  <NavLink className="pHeading cursor-pointer" to="/">
                    <img
                      width="200"
                      src={logoFeeling}
                      alt="Feeling Italy logo"                      
                      className="negative-margin-logo-outside"
                    />
                  </NavLink>
                  <div className={`menu-icon float-end ${background === "white" ? "burger-black" : "burger-white"}`} onClick={openMenu}>
                    <span className="barOne"></span>
                    <span className="barTwo"></span>
                    <span className="barThree"></span>
                  </div>
                  <div id="Menu" className="nav-elements px-4">
                    <NavLink className="pHeading" to="/">
                      <img
                        width="200"
                        src={companyLogoWhite}
                        alt="Feeling Italy logo"
                        className="negative-margin-logo-inside"
                      />
                    </NavLink>
                    <div className="menu-icon float-end" onClick={closeMenu}>
                      <span className="closeMenu"></span>
                    </div>
                    <div className="overflowLand mb-5 mt-4">
                    <SearchFilter closeMenu={closeMenu}/>
                      <ul className="pt-4 text-center">
                        {MenuLink.map((item, index) => (
                          item.position === "Header" &&
                          (<li key={index}>
                              <NavLink to={item.href} className={item.class} onClick={closeMenu}>
                                {item.text}
                              </NavLink>

                            </li>
                          )
                        ))}
                      </ul>
                      <BookNowMobile closeMenu={closeMenu}/>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-lg-2 container-logo-menu">
                    <NavLink className="cursor-pointer" to={"/"}>
                      <img
                        className="logo-header"
                        src={logoFeeling}
                        alt="Feeling Italy logo"
                      />
                    </NavLink>
                  </div>
                  <div className={isHomePage ? "col-lg-8" : "col-lg-10"}>
                    <div className="row">
                    <div className="col-lg-8 offset-1 menu-header">
                    <ul className="d-flex justify-content-center mb-0">
                      {MenuLink.map((item, index) => (
                        item.position === "Header" &&
                        (
                          <li key={index}>
                            <NavLink to={item.href} className={`${(background === "transparent" || background === "black") ? "lineEffect text-white" : "lineEffectBlack text-black"} ${item.class}`}>
                              {item.text}
                            </NavLink>
                          </li>
                        )
                      ))}
                    </ul>
                    </div>
                    <div className="col-lg-3 d-flex align-items-center justify-content-start">
                      <div className="container-btn-book-now">
                    <BookNow closeMenu={closeMenu}/>
                      </div>
                    </div>
                    </div>
                  </div>
                  {isHomePage && (
                    <div className="col-lg-2 d-flex align-items-center">
                      <SearchFilter />
                    </div>
                  )}

                </div>
              )}
            </div>
          </div>
        </div>
      </header>
  );
};

export default Header;
